<template>
    <div class="row mb-2">
        <div class="col rounded-start d-flex flex-row justify-content-center align-items-center bg-orange text-white display-4 text number">
            {{ priority }}
        </div>
        <div class="col bg-light rounded-end-1 d-flex flex-column justify-content-center align-items-start me-2">
            <div class="h3 mb-0">{{ item.firstname }} {{ item.lastname}}</div>
            <div class="h5 fw-normal mb-0 mt-1 d-flex flex-row align-items-center">
                <SeatIcon />
                <span class="mt-1">{{ item.passengerNumber }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import SeatIcon from "./Icon/SeatIcon.vue";

export default {
    name: "TransportCard",
    components: {SeatIcon},
    props: {
        item: {
            type: Object,
            required: true
        },
        priority: {
            type: Number,
            required: true
        }
    }
}
</script>

<style scoped>
    .number {
        height: 80px;
        max-width: 80px;
    }
</style>
